import { render, staticRenderFns } from "./checkoutV7.vue?vue&type=template&id=45672945&scoped=true"
import script from "./checkoutV7.vue?vue&type=script&lang=js"
export * from "./checkoutV7.vue?vue&type=script&lang=js"
import style0 from "./checkoutV7.vue?vue&type=style&index=0&id=45672945&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45672945",
  null
  
)

export default component.exports